import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";
import { K1DocumentsTable } from "./table";
import { K1DocumentsEdit } from "./edit";

export default function K1Documents() {
  useEffect(() => {
    setDocumentTitle("Quantilia | K1 documents");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<K1DocumentsEdit />} />
      <Route index element={<K1DocumentsTable />} />
    </Routes>
  );
}
